/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        common: {
            init: function () {
                // JavaScript to be fired on all pages
                /** GLOBAL VARIABLES */
                var body = document.querySelector("body");
                /** END GLOBAL VARIABLES */

                function itemReveal() {
                    var waypoints = $(".reveal").waypoint({
                        handler: function (direction) {
                            $(this).addClass("revealed");
                        },
                        offset: "90%",
                    });
                }

                itemReveal();

                /** SKIP LINK NAVIGATION */
                $("#skip-to-content").click(function (event) {
                    // strip the leading hash and declare
                    // the content we're skipping to
                    var skipTo = "#" + this.href.split("#")[1];
                    // Setting 'tabindex' to -1 takes an element out of normal
                    // tab flow but allows it to be focused via javascript
                    $(skipTo)
                        .attr("tabindex", -1)
                        .on("blur focusout", function () {
                            // when focus leaves this element,
                            // remove the tabindex attribute
                            $(this).removeAttr("tabindex");
                        })
                        .focus(); // focus on the content container
                });
                /** END SKIP LINK NAVIGATION */

                /* HEADER SCROLL EFFECT */
                // Reference: http://tympanus.net/codrops/2013/06/06/on-scroll-animated-header/
                var animatedHeader = (function () {
                    var didScroll = false,
                        scrollOffset = 0;
                    function scrollY() {
                        return (
                            window.pageYOffset ||
                            document.documentElement.scrollTop
                        );
                    }
                    function scrollPage() {
                        var sy = scrollY();
                        if (sy > scrollOffset) {
                            body.classList.add("scroll-triggered");
                        } else {
                            body.classList.remove("scroll-triggered");
                        }
                        didScroll = false;
                    }
                    function init() {
                        window.addEventListener("load", scrollPage);
                        window.addEventListener(
                            "scroll",
                            function (event) {
                                if (!didScroll) {
                                    didScroll = true;
                                    setTimeout(scrollPage, 250);
                                }
                            },
                            false
                        );
                    }
                    init();
                })();
                /* END HEADER SCROLL EFFECT */

                /** RESPONSIVE NAV OPEN/CLOSE **/
                var mobileNav = document.querySelector("#mobile-nav");
                var mobileNavButton =
                    document.querySelector("#mobile-nav-icon");

                // Toggle menu icon
                if (mobileNavButton) {
                    mobileNavButton.addEventListener("click", function () {
                        body.classList.toggle("mobile-nav-open");
                    });
                }

                // Close menu if page is clicked (not menu item)
                if (mobileNav) {
                    mobileNav.addEventListener("click", function (e) {
                        // Don't hide if click is on a child element (nav link)
                        if (e.target !== this) {
                            return;
                        }
                        mobileNavButton.classList.toggle("opened");
                        $("#nav-toggle").prop("checked", false);
                    });
                }
                /** END RESPONSIVE NAV OPEN/CLOSE **/

                /** SHOW AND HIDE SEARCH BAR **/
                var searchButton = $("#search-button"),
                    headerMain = $("#header-main"),
                    headerSearch = $("#search-overlay"),
                    searchClose = $("#search-close");

                searchButton.click(function (e) {
                    e.preventDefault();
                    headerSearch.addClass("search-overlay--active");
                    // Focus on input
                    setTimeout(function () {
                        $("#site-search").focus();
                    }, 1500);
                });
                searchClose.click(function () {
                    headerSearch.removeClass("search-overlay--active");
                });
                // Shake Animation
                function shake(div) {
                    var interval = 100;
                    var distance = 10;
                    var times = 4;
                    $(div).css("position", "relative");
                    for (var iter = 0; iter < times + 1; iter++) {
                        $(div).animate(
                            { left: iter % 2 === 0 ? distance : distance * -1 },
                            interval
                        );
                    }
                    $(div).animate({ left: 0 }, interval);
                }
                // Search Submit
                headerSearch.submit(function (e) {
                    var s = $(this).find('input[type="text"]');
                    if (!s.val()) {
                        e.preventDefault();
                        shake($(this).find('input[type="text"]'));
                        $(this).find('input[type="text"]').focus();
                    }
                });
                /** END SHOW OR HIDE SEARCH BAR **/

                /** FULL WIDTH ROWS */
                function fullWidthRows() {
                    var wrapperClass = ".container";
                    var element = $(".full-width");
                    var width = element.closest(wrapperClass).width();
                    var spacing = ($(window).width() - width) / 2;

                    element.css({
                        "margin-left": -spacing,
                        "margin-right": -spacing,
                        "padding-left": 0,
                        "padding-right": 0,
                    });
                }
                $(window).load(fullWidthRows);
                $(window).resize(fullWidthRows);
                /** END FULL WIDTH ROWS */

                /* RESPONSIVE IFRAMES */
                var $iframes = $(".entry-content iframe");
                // Only add wrapper if it's a youtube iframe
                $iframes.each(function () {
                    if ($(this).attr("src").includes("youtube")) {
                        $(this).wrap('<div class="iframe-wrap"></div>');
                    }
                    if ($(this).attr("src").includes("vimeo")) {
                        $(this).css({ "max-width": "100%" });
                    }
                });

                /** MASTHEAD PRGRESSIVE IMAGES **/
                var masthead = document.querySelector(".masthead"),
                    placeholderOverlay = document.querySelector(
                        ".placeholder-overlay"
                    );

                if (masthead && placeholderOverlay) {
                    // Load full size image. When loaded, fade our placeholder add it as bg to masthead
                    var img = new Image();
                    img.src = masthead.dataset.imageSrc;
                    img.onload = function () {
                        placeholderOverlay.classList.add("fade-out");
                        masthead.style.backgroundImage = "url(" + img.src + ")";
                    };
                }
                /** END MASTHEAD PRGRESSIVE IMAGES **/

                /** ANIMATED ANCHOR LINKS **/
                $('a[href*="#"]:not([href="#"])').click(function (e) {
                    if (!$(this).closest("li").hasClass("vc_tta-tab")) {
                        if (
                            !$(this)
                                .closest("h4")
                                .hasClass("vc_tta-panel-title")
                        ) {
                            if (
                                location.pathname.replace(/^\//, "") ===
                                this.pathname.replace(/^\//, "") &&
                                location.hostname === this.hostname
                            ) {
                                var target = $(this.hash);
                                var $this = this;
                                var header = $("header.header");
                                var wpAdminBar = $("#wpadminbar");
                                var fixedHeaderOffset =
                                    parseInt(header.outerHeight()) -
                                    parseInt(
                                        header
                                            .css("padding-top")
                                            .replace("px", "")
                                    );
                                // If we're logged in and WP ADmin Bar exists, add it to the offset
                                if (wpAdminBar.length) {
                                    fixedHeaderOffset += parseInt(
                                        wpAdminBar.outerHeight()
                                    );
                                }
                                target = target.length
                                    ? target
                                    : $("[name=" + this.hash.slice(1) + "]");
                                if (target.length) {
                                    $("html,body").animate(
                                        {
                                            scrollTop:
                                                target.offset().top -
                                                fixedHeaderOffset,
                                        },
                                        500,
                                        function () {
                                            if (history.pushState) {
                                                history.pushState(
                                                    null,
                                                    null,
                                                    $this.hash
                                                );
                                            } else {
                                                location.hash = $this.hash;
                                            }
                                        }
                                    );
                                    e.preventDefault();
                                }
                            }
                        }
                    }
                });
                /** END ANIMATED ANCHOR LINKS **/

                /* NUMBER TICKER UPON VIEW */
                // IMPORTANT: Requires Waypoint.js and Counterup.js (Enqueued from JSDelivr)
                var numberTickers = $(".ticker");
                if (numberTickers.length) {
                    numberTickers.counterUp({
                        time: 700,
                    });
                }
                /* END NUMBER TICKER UPON VIEW */

                /* GENERIC SLIDER */
                $(
                    ".visceral-slider:not(.vc_row):not(.vc_column_container)"
                ).slick({
                    draggable: true,
                    dots: true,
                    infinite: true,
                    arrows: false,
                    fade: true,
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 7000,
                });

                $(
                    ".visceral-slider.vc_row > .wpb_column > .vc_column-inner > .wpb_wrapper"
                ).slick({
                    draggable: true,
                    dots: true,
                    infinite: true,
                    arrows: false,
                    // centerMode: true,
                    slidesToShow: 1,
                    fade: true,
                    autoplay: true,
                    autoplaySpeed: 7000,
                });

                $(
                    ".visceral-slider.vc_column_container > .vc_column-inner > .wpb_wrapper"
                ).slick({
                    draggable: true,
                    dots: true,
                    infinite: true,
                    arrows: false,
                    // centerMode: true,
                    slidesToShow: 1,
                    fade: true,
                    autoplay: true,
                    autoplaySpeed: 7000,
                });
                /* END GENERIC SLIDER */

                $(".featured-content").append(
                    '<div class="featured-content__progress-bar"></div>'
                );

                var $featuredSlides = $(".featured-content__slide-container");

                $featuredSlides.slick({
                    draggable: true,
                    dots: true,
                    infinite: true,
                    arrows: false,
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 7000,
                    fade: true,
                });

                // Change active control on slide change
                $featuredSlides.on(
                    "afterChange",
                    function (event, slick, currentSlide) {
                        startProgressBar();
                    }
                );

                // Progress Bar

                // Variables
                var time = 10;
                var $progressBar = $(".featured-content__progress-bar");
                var tick, percentTime;

                function startProgressBar() {
                    resetProgressBar();
                    percentTime = 0;
                    // Every 10ms run the interval function
                    tick = setInterval(interval, 10);
                }

                function interval() {
                    // Increase progress bar's width by a percentage relative to the time
                    percentTime += 1 / (time + 0.1);
                    $progressBar.css({
                        width: percentTime + "%",
                    });
                    // If it maes it to 100%, restart the process
                    if (percentTime >= 100) {
                        $featuredSlides.slick("slickNext");
                        startProgressBar();
                    }
                }

                function resetProgressBar() {
                    $progressBar.css({
                        width: 0 + "%",
                    });
                    clearTimeout(tick);
                }

                startProgressBar();

                // .center-underline wrapper
                $(".center-underline").wrap(
                    '<div class="center-underline-wrapper"></div>'
                );

                /* VIDEO MODALS */
                $(".video-modal").magnificPopup({
                    type: "iframe",
                    iframe: {
                        markup:
                            '<div class="mfp-iframe-scaler">' +
                            '<div class="mfp-close"></div>' +
                            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                            '<div class="mfp-title">Some caption</div>' +
                            "</div>",
                    },
                    callbacks: {
                        markupParse: function (template, values, item) {
                            values.title = item.el.attr("title");
                        },
                    },
                });
                /* END VIDEO MODALS */

                // Mobile Nav
                $("#mobile-nav li.menu-item-has-children").append("<i></i>");

                $("#mobile-nav li.menu-item-has-children i").on(
                    "click",
                    function () {
                        $(this).prev("ul").slideToggle("fast");
                        $(this).toggleClass("sub-menu-active");
                    });
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            },
        },
        // Home page
        home: {
            init: function () {
                /** VIDEO BG */
                if (window.innerWidth > 768) {
                    $(".player").YTPlayer();
                }

                /** SLIDES */
                if (window.innerWidth > 768) {
                    $(document).alton({
                        fullSlideContainer:
                            "homepage-slides__container .wpb-content-wrapper", // Tell Alton the full height container
                        firstClass: "header",
                        lastClass: "site-footer",
                        singleSlideClass: "homepage-slide", // Tell Alton the full height slide class
                        useSlideNumbers: true, // Set to false if you don't want to use pagination
                        slideNumbersBorderColor: "#fff", // Set the outside color of the pagination items
                        slideNumbersColor: "transparent", // Set the inner color of the pagination items
                        bodyContainer: "home", // Tell Alton the body class
                    });

                    // Fixes bug where middle indicator is active on load
                    if (document.documentElement.scrollTop <= 32) {
                        setTimeout(function () {
                            $("#slide-numbers li").each(function () {
                                $(this).removeClass("active");
                            });
                            $("#slide-numbers li:first-child").addClass(
                                "active"
                            );
                        }, 100);
                    }
                }
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            },
        },
        // our Work
        our_work: {
            init: function () {
                // JavaScript to be fired on the Our Work page

                $(".regions-slider__slide-container").slick({
                    draggable: true,
                    dots: false,
                    infinite: true,
                    arrows: false,
                    slidesToShow: 1,
                    autoplay: false,
                    autoplaySpeed: 8000,
                    fade: true,
                });

                /** VIDEO BG */

                $(".player").YTPlayer();

                var $slideControls = $(".regions-slider__navigation li");

                //   Change slide when a control is clicked
                $slideControls.each(function () {
                    var $this = $(this);
                    var index = $this.data("control-index");

                    $this.on("click", function () {
                        $(".regions-slider__slide-container").slick(
                            "slickGoTo",
                            index
                        );
                        $slideControls.each(function () {
                            $(this).removeClass(
                                "regions-slider__navigation__item--active"
                            );
                        });
                        $(this).addClass(
                            "regions-slider__navigation__item--active"
                        );
                    });
                });

                // Change active control on slide change
                $(".regions-slider__slide-container").on(
                    "afterChange",
                    function (event, slick, currentSlide) {
                        $slideControls.each(function () {
                            var $this = $(this);
                            $this.removeClass(
                                "regions-slider__navigation__item--active"
                            );
                            if ($this.data("control-index") === currentSlide) {
                                $this.addClass(
                                    "regions-slider__navigation__item--active"
                                );
                            }
                        });
                    }
                );

                // Parallax
                function imageParallax() {
                    var $window = $(window);
                    var wScroll = $window.scrollTop();
                    var wHeight = $window.height();
                    var wScrollBottom = wScroll + wHeight;
                    var parallaxImageFirst = $(".parallax-image-1");
                    var pImageSecond = $(".parallax-image-2");

                    parallaxImageFirst.each(function () {
                        var elTop = $(this).offset().top;
                        var change;
                        if (elTop < wHeight) {
                            change = wScroll;
                        } else {
                            change = wScrollBottom - elTop;
                        }
                        if (wScrollBottom > elTop) {
                            $(this).css({
                                transform: "translateY(-" + change / 40 + "%)",
                            });
                        }
                    });
                    pImageSecond.each(function () {
                        var elTop = $(this).offset().top;
                        var change;
                        if (elTop < wHeight) {
                            change = wScroll;
                        } else {
                            change = wScrollBottom - elTop;
                        }
                        if (wScrollBottom > elTop) {
                            $(this).css({
                                transform: "translateY(-" + change / 28 + "%)",
                            });
                        }
                    });
                }
                if (window.innerWidth > 768) {
                    $(window).scroll(imageParallax);
                }
            },
        },
        // Stories
        page_template_template_stories: {
            init: function () {
                // JavaScript to be fired on the Stories page

                var infowindow = new google.maps.InfoWindow();

                function render_map($el) {
                    var styles = [
                        {
                            elementType: "labels",
                            stylers: [
                                {
                                    visibility: "off",
                                },
                            ],
                        },
                        {
                            featureType: "administrative",
                            elementType: "geometry.stroke",
                            stylers: [
                                {
                                    color: "#ffffff",
                                },
                            ],
                        },
                        {
                            featureType: "administrative.land_parcel",
                            stylers: [
                                {
                                    visibility: "off",
                                },
                            ],
                        },
                        {
                            featureType: "administrative.neighborhood",
                            stylers: [
                                {
                                    visibility: "off",
                                },
                            ],
                        },
                        {
                            featureType: "landscape",
                            elementType: "geometry",
                            stylers: [
                                {
                                    color: "#9dc6d5",
                                },
                            ],
                        },
                        {
                            featureType: "road",
                            stylers: [
                                {
                                    visibility: "off",
                                },
                            ],
                        },
                        {
                            featureType: "water",
                            elementType: "geometry.fill",
                            stylers: [
                                {
                                    color: "#e8f1f5",
                                },
                            ],
                        },
                    ];

                    // var
                    var $markers = $el.find(".marker");

                    // vars
                    var args = {
                        disableDefaultUI: true,
                        panControl: true,
                        zoomControl: true,
                        draggable: true,
                        scrollwheel: false,
                        mapTypeId: "roadmap",
                    };

                    // create map
                    var map = new google.maps.Map($el[0], args);
                    map.setOptions({ styles: styles });
                    map.setZoom(4.5);
                    map.setCenter(
                        new google.maps.LatLng(37.6645261, -97.5837766)
                    );

                    // add a markers reference
                    map.markers = [];

                    // add markers
                    $markers.each(function () {
                        add_marker($(this), map);
                    });
                }

                function add_marker($marker, map) {
                    var mappinurl = $marker.attr("data-map-pin");
                    var image = {
                        url: mappinurl,
                        // This marker is 20 pixels wide by 32 pixels tall.
                        size: new google.maps.Size(34, 45),
                        // The origin for this image is 0,0.
                        origin: new google.maps.Point(0, 0),
                        // The anchor for this image is the base of the flagpole at 0,32.
                        anchor: new google.maps.Point(17, 45),
                    };

                    // var
                    var latlng = new google.maps.LatLng(
                        $marker.attr("data-lat"),
                        $marker.attr("data-lng")
                    );

                    // create marker
                    var marker = new google.maps.Marker({
                        position: latlng,
                        map: map,
                        icon: image,
                    });

                    // add to array
                    map.markers.push(marker);

                    // if marker contains HTML, add it to an infoWindow
                    if ($marker.html()) {
                        // show info window when marker is clicked
                        google.maps.event.addListener(
                            marker,
                            "click",
                            function () {
                                infowindow.setContent($marker.html());
                                infowindow.open(map, marker);
                            }
                        );
                    }
                }

                $(document).ready(function () {
                    $(".stories-map__map").each(function () {
                        render_map($(this));
                    });
                });
            },
        },
        // Search Our Grants
        page_template_template_search_our_grants: {
            init: function () {
                // JavaScript to be fired on the Search Our Grants page

                $(".grant-header").on("click", function () {
                    $(this)
                        .closest(".list-item-grant")
                        .toggleClass("list-item-grant--active");
                    $(this).next().slideToggle("fast");
                });
            },
        },
        // Careers
        careers: {
            init: function () {
                // Smoothly scroll to job description if it's on the page
                const urlQuery = window.location.search,
                    openPositions = document.querySelector("#open-positions"),
                    offset = openPositions.offsetTop;

                $(window).load(function () {
                    if (urlQuery.includes("gh_jid")) {
                        $("html,body").animate(
                            {
                                scrollTop: offset,
                            },
                            1000
                        );
                    }
                });
            },
        },
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = funcname === undefined ? "init" : funcname;
            fire = func !== "";
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === "function";

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire("common");

            // Fire page-specific init JS, and then finalize JS
            $.each(
                document.body.className.replace(/-/g, "_").split(/\s+/),
                function (i, classnm) {
                    UTIL.fire(classnm);
                    UTIL.fire(classnm, "finalize");
                }
            );

            // Fire common finalize JS
            UTIL.fire("common", "finalize");
        },
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
